export default "__VITE_ASSET__1ac41e97__"